module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-locked-ac3870b47e573ac94b3aa693c95d78e4.svg";